import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateSubgroupService } from 'src/app/shared/services/API/pharmacy/template-subgroup.service';


@Component({
  selector: 'app-template-subgroup-delete-modal',
  templateUrl: './template-subgroup-delete-modal.component.html',
  styleUrls: ['./template-subgroup-delete-modal.component.css']
})
export class TemplateSubgroupDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<TemplateSubgroupDeleteModalComponent>,
    private templateSubgroupService: TemplateSubgroupService,
    private alertService: AlertService,
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteTemplateSubgroup: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.templateSubgroupService.delete(this.data.idTemplateSubgroup).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.alertService.show('Sucesso', "Subgrupo excluido com sucesso!", AlertType.success); 
      this.matDialogRef.close({deleteTemplateSubgroup: true}); 
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteTemplateSubgroup: false}); 
  }
}